import type { LearnedSense } from '@/types/content'
import type { LocalizedSense } from '@/types/user'

export function isSenseLearned(
  senseKey: string | undefined,
  translation: string | null | undefined,
  learnedSenses: LearnedSense[],
): boolean {
  return learnedSenses.some((learned) => {
    if (senseKey && learned.senseKey === senseKey) {
      return true
    }
    if (!learned.senseKey) {
      const a = learned.translation?.trim().toLowerCase() ?? ''
      const b = translation?.trim().toLowerCase() ?? ''
      return a !== '' && a === b
    }
    return false
  })
}

export function resolveLearningSenseIndex(
  senses: LocalizedSense[],
  learningSenseIndex: number,
  senseKey?: string,
): number {
  if (senseKey) {
    const byKey = senses.findIndex((s) => s.senseKey === senseKey)
    if (byKey >= 0) {
      return byKey
    }
  }
  return learningSenseIndex
}

/** Learner-facing gloss in the study language (English). */
export function senseStudyGloss(sense: LocalizedSense): string {
  return sense.englishGloss?.trim() || sense.translation?.trim() || ''
}

/** Native-language hint shown under the English gloss when available. */
export function senseNativeHint(sense: LocalizedSense): string | null {
  const studyGloss = sense.englishGloss?.trim()
  const translation = sense.translation?.trim()
  const nativeGloss = sense.nativeGloss?.trim()

  if (nativeGloss && nativeGloss !== studyGloss && nativeGloss !== translation) {
    return nativeGloss
  }
  if (studyGloss && translation && translation.toLowerCase() !== studyGloss.toLowerCase()) {
    return translation
  }
  return null
}
